import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  availableVersions: [],
  selectedDowngradeVersion: null,
  versionData: null,
  deployStatus: null,
  dismissedDeployment: false,
};

export const WarrantyManagementSlice = createSlice({
  name: "WarrantyManagement",
  initialState,
  reducers: {
    updateWarrantyData: (state, action) => {
      const { type, value } = action.payload;
      state[type] = value;
    },

    setAvailableVersions: (state, action) => {
      state.availableVersions = action.payload;
    },
    setSelectedDowngradeVersion: (state, action) => {
      state.selectedDowngradeVersion = action.payload;
    },
    setVersionData: (state, action) => {
      state.versionData = action.payload;
    },
    setDeployStatus: (state, action) => {
      state.deployStatus = action.payload;
    },
    setDismissedDeployment: (state, action) => {
      state.dismissedDeployment = action.payload;
    },
    resetWarrantyState: () => initialState,
  },
});

export const {
  updateWarrantyData,
  setAvailableVersions,
  setSelectedDowngradeVersion,
  resetWarrantyState,
  setVersionData,
  setDeployStatus,
  setDismissedDeployment,
} = WarrantyManagementSlice.actions;

export default WarrantyManagementSlice.reducer;
